import { Component, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CommonModule,Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { RoleViewService } from '../services/role-view.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GraphProfileService } from '../services/graph-profile.service';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  profileDropdownOpen = false;
  userName: any = '';
  workDayId: any = '';
  userProfile: any = {};
  currentViewRole: any = '';
  availableRoles: string[] = [];
  canToggleRole = false;
  private readonly subscriptions: Subscription[] = [];
  private profileObjectUrl: string | null = null;
  location: Location;

  constructor(
    location: Location,
    private readonly elementRef: ElementRef,
    private readonly router: Router,
    private readonly roleViewService: RoleViewService,
    private readonly graphProfileService: GraphProfileService
  ) {
    this.location = location;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.profileDropdownOpen) {
      return;
    }

    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeProfileDropdown();
    }
  }

  ngOnInit(): void {
    this.getUserInfo();
    this.initializeRoleData();

    // Subscribe to view role changes
    const viewRoleSub = this.roleViewService.getViewRole$().subscribe(role => {
      this.currentViewRole = role;
      this.initializeRoleData();
      this.userProfile = {
        ...this.userProfile,
        jobTitle: this.roleViewService.getJobTitle()
      };
    });
    this.subscriptions.push(viewRoleSub);

    // Subscribe to username changes so header updates after login
    const userNameSub = this.roleViewService.getUserName$().subscribe(name => {
      if (name) {
        this.userName = name;
        this.userProfile = {
          ...this.userProfile,
          name: this.userName
        };
      }
    });
    this.subscriptions.push(userNameSub);

    void this.loadProfilePhotoFromGraph();
  }

  private initializeRoleData(): void {
    this.availableRoles = this.roleViewService.getAvailableRoles();
    this.canToggleRole = this.roleViewService.canToggleRole();
    this.currentViewRole = this.roleViewService.getViewRole();
  }

  getUserInfo() {
    // Always take the username from RoleViewService
    this.userName = this.roleViewService.getUserName();
    this.workDayId = this.roleViewService.getWorkdayId();
    console.info('userName', this.userName);

    this.userProfile = {
      name: this.userName,
      jobTitle: this.roleViewService.getJobTitle(),
      profilePic: ''
    };
  }

  private async loadProfilePhotoFromGraph(): Promise<void> {
    const emailForLookup = this.roleViewService.getUserEmail();
    const profilePic = await this.graphProfileService.fetchProfilePhoto(emailForLookup);

    if (profilePic) {
      if (this.profileObjectUrl) {
        URL.revokeObjectURL(this.profileObjectUrl);
      }

      this.profileObjectUrl = profilePic;
      this.userProfile = {
        ...this.userProfile,
        profilePic
      };
    }
  }

  switchRole(role: string): void {
    this.roleViewService.setViewRole(role);
    this.closeProfileDropdown();

    // Navigate to appropriate page based on selected role
    if (role.toLowerCase().includes('user')) {
      this.router.navigate(['/user-dashboard']);
    } else {
      // Navigate back to admin dashboard/home
      this.router.navigate(['/']);
    }
  }

  getRoleDisplayName(role: string): string {
    if (!role) { return '' };

    // Remove 'cert.' prefix if present
    const cleanRole = role.replace(/^cert\./i, '');

    // Map roles to display names
    if (cleanRole.toLowerCase() === 'superadmin' || cleanRole.toLowerCase() === 'admin') {
      return 'RAES';
    }

    if (cleanRole.toLowerCase() === 'user') {
      return 'User';
    }

    // Default: capitalize first letter
    return cleanRole.charAt(0).toUpperCase() + cleanRole.slice(1);
  }

  onClick() {
    this.router.navigate(['/settings']);
  }

  onClickHome() {
    console.info("clicked");
    this.router.navigate(['/']);
  }

  toggleProfileDropdown() {
    this.profileDropdownOpen = !this.profileDropdownOpen;
  }

  closeProfileDropdown() {
    this.profileDropdownOpen = false;
  }

  hasProfilePhoto(): boolean {
    return !!this.userProfile?.profilePic;
  }

  onLogout() {
    console.info('User logged out');
    sessionStorage.clear();
    globalThis.location.href = environment?.logoutUrl;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());

    if (this.profileObjectUrl) {
      URL.revokeObjectURL(this.profileObjectUrl);
    }
  }

  openHelpAndSupport(): void {
    const role = this.roleViewService.getViewRole() || '';

    if (role.toLowerCase().includes('user')) {
      this.router.navigate(['/user-dashboard'], { queryParams: { tab: 'help' } });
    } else {
      this.router.navigate(['/help-support']);
    }
  }
}

